type classAction = 'add' | 'remove';

export const applyClass = (action: classAction, el: HTMLElement | null, className: string): void => {
  if (el) {
    el.classList[action](className);
  }
};



// WEBPACK FOOTER //
// ./src/utils/applyClass.ts